export default __webpack_public_path__ + "static/media/Build-a-Team-to-Create.b2aade58.jpg";